// Маска українського телефону: +380 (XX) XXX-XX-XX — поля з data-phone-mask="ua" (каса, кабінет).
// Вставка приймається в будь-якому вигляді: 067…, 380…, +38 067…. Сервер однаково нормалізує
// й перевіряє номер (helixwave_normalize_ua_phone у inc/woocommerce.php).
const PREFIX = '+380 (';

// 9 цифр національного номера без коду країни і без «0» на початку.
const digitsOf = (value) => {
	let d = value.replace(/\D/g, '');
	if (d.startsWith('380')) d = d.slice(3);
	else if (d.startsWith('80') && d.length === 11) d = d.slice(2);
	if (d.startsWith('0')) d = d.slice(1);
	return d.slice(0, 9);
};

// Роздільники додаємо лише перед наступною цифрою, щоб Backspace завжди стирав цифру.
const format = (d) => {
	let out = PREFIX + d.slice(0, 2);
	if (d.length > 2) out += ') ' + d.slice(2, 5);
	if (d.length > 5) out += '-' + d.slice(5, 7);
	if (d.length > 7) out += '-' + d.slice(7, 9);
	return out;
};

// Позиція курсора після n-ї цифри національного номера.
const caretAfter = (formatted, n) => {
	if (n <= 0) return PREFIX.length;
	let seen = 0;
	for (let i = PREFIX.length; i < formatted.length; i++) {
		if (/\d/.test(formatted[i]) && ++seen === n) return i + 1;
	}
	return formatted.length;
};

// invalid: false | 'empty' (обовʼязкове поле порожнє — лише червона рамка, як у WooCommerce) | 'partial'.
const setError = (input, invalid) => {
	const row = input.closest('.form-row');
	let msg = row && row.querySelector('.field-error');
	if (row && !msg) {
		msg = document.createElement('span');
		msg.className = 'field-error';
		msg.id = `${input.id}-error`;
		msg.textContent = 'Вкажіть номер повністю: 9 цифр після +380.';
		(input.parentElement || row).appendChild(msg);
	}
	if (row) {
		row.classList.toggle('woocommerce-invalid', !!invalid);
		row.classList.toggle('woocommerce-invalid-phone', invalid === 'partial');
		row.classList.toggle('woocommerce-invalid-required-field', invalid === 'empty');
		if (invalid) row.classList.remove('woocommerce-validated');
	}
	if (msg) msg.hidden = invalid !== 'partial';
	input.setAttribute('aria-invalid', invalid ? 'true' : 'false');
	if (invalid === 'partial') input.setAttribute('aria-describedby', msg.id);
};

const SELECTOR = 'input[data-phone-mask="ua"]';

const apply = (input, keepCaret) => {
	const caret = input.selectionStart ?? input.value.length;
	const before = digitsOf(input.value.slice(0, caret)).length;
	const d = digitsOf(input.value);
	input.value = d.length || document.activeElement === input ? format(d) : '';
	if (keepCaret && document.activeElement === input) {
		const pos = caretAfter(input.value, before);
		input.setSelectionRange(pos, pos);
	}
};

// Делегування з document: плагіни доставки перебудовують поля каси, і обробники на самих
// input-ах губилися б разом зі старими елементами.
document.addEventListener('focusin', (e) => {
	const input = e.target;
	if (!input.matches?.(SELECTOR)) return;
	if (!input.value) input.value = PREFIX;
	requestAnimationFrame(() => {
		if (input.selectionStart < PREFIX.length) input.setSelectionRange(input.value.length, input.value.length);
	});
});

// Backspace перед роздільником — перескакуємо його, щоб стерлась цифра, а не «)» чи «-».
document.addEventListener('keydown', (e) => {
	const input = e.target;
	if (e.key !== 'Backspace' || !input.matches?.(SELECTOR) || input.selectionStart !== input.selectionEnd) return;
	let pos = input.selectionStart;
	while (pos > PREFIX.length && !/\d/.test(input.value[pos - 1])) pos--;
	if (pos !== input.selectionStart) input.setSelectionRange(pos, pos);
});

document.addEventListener('input', (e) => {
	const input = e.target;
	if (!input.matches?.(SELECTOR)) return;
	apply(input, true);
	if (input.getAttribute('aria-invalid') === 'true' && digitsOf(input.value).length === 9) setError(input, false);
});

// WooCommerce перевіряє поля на blur (делеговано з форми) і ставить woocommerce-validated —
// наш висновок застосовуємо після нього.
document.addEventListener('focusout', (e) => {
	const input = e.target;
	if (!input.matches?.(SELECTOR)) return;
	// WooCommerce перевіряв поле ще з префіксом «+380 (» і міг визнати порожнє валідним.
	const n = digitsOf(input.value).length;
	if (!n) input.value = '';
	const required = input.closest('.validate-required') !== null;
	setTimeout(() => setError(input, n === 0 ? required && 'empty' : n < 9 && 'partial'), 0);
});

// Номер із профілю (067…, +380…) — одразу показати у форматі маски.
document.querySelectorAll(SELECTOR).forEach((input) => input.value && apply(input, false));
